/* @flow */
/* eslint-disable import/no-commonjs */

module.exports = {
  get TabViewAnimated() {
    return require('./TabViewAnimated').default;
  },
  get TabViewPagerPan() {
    return require('./TabViewPagerPan').default;
  },
  get TabViewPagerScroll() {
    return require('./TabViewPagerScroll').default;
  },
  get TabViewPagerAndroid() {
    return require('./TabViewPagerAndroid').default;
  },
  get TabBar() {
    return require('./TabBar').default;
  },
  get SceneMap() {
    return require('./SceneMap').default;
  },
};



// WEBPACK FOOTER //
// ./node_modules/react-native-tab-view/src/index.js